{
	"name": "prototypey",
	"version": "0.8.0",
	"description": "atproto lexicon typescript toolkit",
	"repository": {
		"type": "git",
		"url": "git+https://github.com/tylersayshi/prototypey.git",
		"directory": "packages/prototypey"
	},
	"homepage": "https://prototypey.org",
	"license": "MIT",
	"main": "./lib/core/main.js",
	"author": {
		"name": "tylersayshi",
		"email": "hi@tylur.dev"
	},
	"type": "module",
	"bin": {
		"prototypey": "./lib/cli/main.js"
	},
	"exports": {
		".": "./lib/core/main.js",
		"./lib/core/*.d.ts": "./lib/core/*.d.ts"
	},
	"files": [
		"lib/",
		"README.md"
	],
	"scripts": {
		"build": "tsdown",
		"lint": "eslint .",
		"test": "vitest run",
		"test:bench": "node core/tests/infer.bench.ts",
		"test:bench:validation": "vitest bench --run tests/validation-baseline.bench.ts",
		"test:update-snapshots": "vitest run -u",
		"tsc": "tsc"
	},
	"dependencies": {
		"@atproto/lexicon": "^0.6.2",
		"sade": "^1.8.1",
		"tinyglobby": "^0.2.16"
	},
	"devDependencies": {
		"@ark/attest": "^0.49.0",
		"@types/node": "24.0.4",
		"tsdown": "^0.15.12",
		"typescript": "5.9.3",
		"vitest": "^3.2.4"
	},
	"engines": {
		"node": ">=20.19.0"
	}
}
